export class StartKitModel {
	constructor(
		public ProductLineCode: string | null,
		public ItemNo: string | null | undefined,
		public VariantCode: string | undefined,
		public Description: string | undefined,
		public KidTeen: boolean,
		public ToolsIncluded: boolean
	) { }
}
